import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-shopping-cart',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map